
















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    name: "SwitchControl",
    props: {
        value: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    setup(props, { emit }) {
        const onChange = (next: boolean) => {
            emit("change", next);
        };

        const displayLabel = computed(() => {
            if (props.disabled) return "N/A";
            if (props.loading) return "Wait...";
            return props.value ? "On" : "Off";
        });

        return {
            onChange,
            displayLabel,
        };
    },
});
